export default "__VITE_PUBLIC_ASSET__b09fb440__"